import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'manufacture_knitted_crocheted_fabrics'

export const dataPointDefinition = {
  retracedId: 'manufacture_knitted_crocheted_fabrics',
  name: 'Manufacture of knitted and crocheted fabrics',
  description:
    'This includes, e.g., manufacture and processing of knitted and crocheted fabrics, such as pile and terry fabrics, net and window furnishing type fabrics knitted on Raschel or similar machines, other knitted or crocheted fabrics, and imitation fur by knitting. Informed by ISIC Code 1391 (See more inf',
  meta: {
    slcpMeta: {
      key: 'fp-pro-24',
      number: 'FP-PRO-2-3',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'fp-pro-2',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1]',
      machineShowHide: '[1]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-pro-24', version: '1.7.0', provider: 'slcp'}],
  sortingId: 28860,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
